import { LOAD_QUESTIONS, SELECT_QUESTION, CLEAN_SELECTED_QUESTION } from "./actionTypes";

export const loadQuestions = questions => ({
    type: LOAD_QUESTIONS,
    questions
});

export const selectQuestion = (question) => ({
    type: SELECT_QUESTION,
    question
});

export const cleanSelectedQuestion = () => ({
    type: CLEAN_SELECTED_QUESTION
});